import React from 'react';
import styles from './helpingText.module.scss';

export const HelpingText = ({label,id}) => (
  <p id={id} className={styles.helpingText}>
    {label}
  </p>
);